const FORCE_WINDOW_RELOAD_DELAY = 60 * 60 * 1000;
let forceWindowReload = false;
if (typeof window !== "undefined" && !window.__forceReloadTimer) {
    window.__forceReloadTimer = setTimeout(() => (forceWindowReload = true), FORCE_WINDOW_RELOAD_DELAY);
}
export const isForceReloadOnNavigationNeeded = () => {
    if (forceWindowReload) {
        forceWindowReload = false;
        return true;
    }
    return false;
};
